import { FC } from 'react'
import TSvgProps from './type/svgPropsType'

interface UpDownIconProps extends TSvgProps {
  isUp: boolean
}

const UpDownIcon: FC<UpDownIconProps> = ({ isUp, ...props }) => {
  return isUp ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <desc>up 아이콘</desc>
      <path fill="none" d="M0 0h32v32H0z" data-name="사각형 30942"></path>
      <g data-name="그룹 43588">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M23.584 12.033a.875.875 0 01-.709 1.388H19.55v14.322A2.266 2.266 0 0117.275 30h-2.8a2.266 2.266 0 01-2.275-2.257V13.421H8.875a.875.875 0 01-.709-1.388l7-9.671a.875.875 0 011.418 0z"
          data-name="패스 16090"
        ></path>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <desc>down 아이콘</desc>
      <path fill="none" d="M0 0h32v32H0z" data-name="사각형 30942"></path>
      <g data-name="그룹 43588">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M8.166 19.967a.875.875 0 01.709-1.388H12.2V4.257A2.266 2.266 0 0114.475 2h2.8a2.266 2.266 0 012.275 2.257v14.322h3.325a.875.875 0 01.709 1.388l-7 9.671a.875.875 0 01-1.418 0z"
          data-name="패스 16090"
        ></path>
      </g>
    </svg>
  )
}

export default UpDownIcon
